module.exports = __webpack_public_path__ + "img/Analyzing.23df6b97.gif";